import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

// import Navbar_v01 from '../../components/demos/Navbar_v01';
// import NavBar_v03LeftRight from '../../components/demos/NavBar_v03LeftRight';
// import NavBar_v03Responsive from './NavBar_v03a_Responsive_component';

import { IAppConfig } from "../App_v01_Interfaces";


interface AppConfigProps{
  appConfig: IAppConfig;
}




const About_v01:  React.FC<AppConfigProps> = ({appConfig}) => {
  return (
    <>
    {/* <NavBar_v03Responsive appConfig={appConfig} /> */}

    <section className="py-5 bg-light">
      <Container>
        {appConfig.AboutPage.Headline}

        {appConfig.AboutPage.Services}
      </Container>
    </section>
    </>

  );
};

export default About_v01;



// const About_v01:  React.FC<AppConfigProps> = ({appConfig}) => {
//   return (
//     <>
//       {/* <Navbar_v01 appConfig={appConfig}/> */}

//       <NavBar_v03LeftRight appConfig={appConfig} />
//       <div className='container mt-5'>
//         <h2>About_v01</h2>
//         <p>Welcome to the About_v01 page of Cost Crusher Insurance.</p>
//       </div>
//     </>
//   );
// };

// export default About_v01;
